module.exports = __webpack_public_path__ + "static/SignatureCollection_liga2-699ffd7b5ed763dd7b57c35dc83dbab5.otf";